import { Res } from 'common/types/responses'
import { Req } from 'common/types/requests'
import { service } from 'common/service'
import { toFormData } from '@hoxtonmix/utils'

export const auditService = service
  .enhanceEndpoints({
    addTagTypes: ['Audit', 'AuditAction', 'AuditDocumentUpload'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      createAuditAction: builder.mutation<
        Res['auditAction'],
        Req['auditAction']
      >({
        invalidatesTags: (result, error, arg) => [
          { id: arg.audit_id, type: 'Audit' },
          { id: 'LIST', type: 'Audit' },
        ],
        query: (query: Req['auditAction']) => ({
          body: query,
          method: 'POST',
          url: `partners/riskaudits/${query.audit_id}/${query.action}`,
        }),
      }),
      createAuditDocumentUpload: builder.mutation<
        Res['auditDocumentUpload'],
        Req['auditDocumentUpload']
      >({
        invalidatesTags: (result, error, arg) => [
          { id: arg.audit_id, type: 'Audit' },
          { id: 'LIST', type: 'Audit' },
        ],
        query: ({ audit_id, ubo_id, ...rest }: Req['auditDocumentUpload']) => ({
          body: toFormData({
            ...rest,
          }),
          method: 'POST',
          url: `partners/riskaudits/${audit_id}/ubos/${ubo_id}/documents`,
        }),
      }),
      getAudit: builder.query<Res['audit'], Req['getAudit']>({
        providesTags: (res) => [{ id: res?.id, type: 'Audit' }],
        query: (query: Req['getAudit']) => ({
          url: `partners/riskaudits/${query.id}`,
        }),
      }),
      getAudits: builder.query<Res['audits'], Req['getAudits']>({
        providesTags: [{ id: 'LIST', type: 'Audit' }],
        query: () => ({
          url: `partners/riskaudits`,
        }),
      }),
      // END OF ENDPOINTS
    }),
  })

export async function getAudits(
  store: any,
  data: Req['getAudits'],
  options?: Parameters<typeof auditService.endpoints.getAudits.initiate>[1],
) {
  return store.dispatch(
    auditService.endpoints.getAudits.initiate(data, options),
  )
}
export async function getAudit(
  store: any,
  data: Req['getAudit'],
  options?: Parameters<typeof auditService.endpoints.getAudit.initiate>[1],
) {
  return store.dispatch(auditService.endpoints.getAudit.initiate(data, options))
}
export async function createAuditAction(
  store: any,
  data: Req['auditAction'],
  options?: Parameters<
    typeof auditService.endpoints.createAuditAction.initiate
  >[1],
) {
  return store.dispatch(
    auditService.endpoints.createAuditAction.initiate(data, options),
  )
}
export async function createAuditDocumentUpload(
  store: any,
  data: Req['auditDocumentUpload'],
  options?: Parameters<
    typeof auditService.endpoints.createAuditDocumentUpload.initiate
  >[1],
) {
  return store.dispatch(
    auditService.endpoints.createAuditDocumentUpload.initiate(data, options),
  )
}
// END OF FUNCTION_EXPORTS

export const {
  useCreateAuditActionMutation,
  useCreateAuditDocumentUploadMutation,
  useGetAuditQuery,
  useGetAuditsQuery,
  // END OF EXPORTS
} = auditService

/* Usage examples:
const { data, isLoading } = useGetAuditsQuery({ id: 2 }, {}) //get hook
const [createAudits, { isLoading, data, isSuccess }] = useCreateAuditsMutation() //create hook
auditService.endpoints.getAudits.select({id: 2})(store.getState()) //access data from any function
*/
